import type { Context, Middleware } from "@/common/types/router"

const middlewarePipeline = (context: Context, middleware: Middleware[], index: number) => {
    const nextMiddleware = middleware[index]

    if (!nextMiddleware) {
        return context.next
    }

    return () => {
        nextMiddleware({
            ...context,
            nextMiddleware: middlewarePipeline(context, middleware, index + 1)
        })
    }
}

export default middlewarePipeline
